export enum InterestType {
  FIXED_RATE = "FIXED_RATE",
  VARIABLE_RATE = "VARIABLE_RATE",
}
